(function () {
    // https://github.com/yieldlove/wrapper_integration_demo_react/blob/main/README.md

    const init = function () {
        let timer = 0;
        let lastWidth = window.innerWidth;
        let lastIsLandscape = isLandscape();

        window.onresize = () => {
            startTime = performance.now();

            let curWidth = window.innerWidth;
            let curIsLandscape = isLandscape();

            // mobile : url bar can affect the window height size
            if (lastWidth === curWidth && lastIsLandscape === curIsLandscape) {
                return;
            }

            lastWidth = curWidth;
            lastIsLandscape = curIsLandscape;

            if (timer) {
                clearTimeout(timer);
            }

            destroySlots();

            timer = setTimeout(() => initSlots(), 500);
        };

        initSlots();
    };

    const isLandscape = function () {
        return window.innerWidth > window.innerHeight;
    };

    /**
     * @return {NodeList}
     */
    const getSlots = function () {
        return document.querySelectorAll(".agw");
    };

    const initSlots = function () {
        getSlots().forEach((element) => initSlot(element));
    };

    const canDestroySlot = function () {
        return googletag && typeof googletag.destroySlots === "function";
    };

    const destroySlot = function (element) {
        if (canDestroySlot()) {
            const googleSlots = googletag
                .pubads()
                .getSlots()
                .filter((slot) => {
                    const slotId = slot.getSlotElementId();

                    if (!slotId) {
                        return false;
                    }

                    const adDiv = document.getElementById(slotId);

                    // Détruire uniquement le slot contenu dans cet élément
                    return adDiv !== null && element.contains(adDiv);
                });

            if (googleSlots.length) {
                googletag.destroySlots(googleSlots);
            }
        }

        element.innerHTML = "";
    };

    const destroySlots = function () {
        if (canDestroySlot()) {
            const googleSlots = googletag
                .pubads()
                .getSlots()
                .filter((slot) => {
                    const slotId = slot.getSlotElementId();

                    if (!slotId) {
                        return false;
                    }

                    const adDiv = document.getElementById(slotId);

                    // Détruire si le div n'existe plus
                    // ou s'il est contenu dans un slot .agw
                    return !adDiv || adDiv.closest(".agw") !== null;
                });

            if (googleSlots.length) {
                googletag.destroySlots(googleSlots);
            }
        }

        getSlots().forEach((element) => {
            element.innerHTML = "";
        });
    };

    /**
     * @param {*} input
     * @param {number} defaultValue
     * @returns {number}
     */
    const parseIntAttr = function (input, defaultValue) {
        const value = input === null ? NaN : parseInt(input, 10);
        return isNaN(value) ? defaultValue : value;
    };

    /**
     * @param {*} input
     * @param {number} defaultValue
     * @returns {number}
     */
    const parseFloatAttr = function (input, defaultValue) {
        const value = input === null ? NaN : parseFloat(input);
        return isNaN(value) ? defaultValue : value;
    };

    /**
     * @param {Node} element
     */
    const initSlot = function (element) {
        if (!element.id) {
            return;
        }

        if (window.getComputedStyle(element).display === "none") {
            return;
        }

        initTemplate(element);
    };

    const getBroadcast = function (element) {
        if (!window.CONFIG.agw_broadcast) {
            return;
        }

        const data = {
            domain: window.CONFIG.agenda.domain,
            uri: window.location.pathname,
            target: element.id,
            width: element.offsetWidth,
            height: element.offsetHeight,
            lat: window.CONFIG.agw_broadcast.lat,
            lon: window.CONFIG.agw_broadcast.lon,
            preview: window.CONFIG.agw_broadcast.preview,
        };

        const controller = new AbortController();
        const signal = controller.signal;

        const timeoutId = setTimeout(() => {
            controller.abort();
        }, 5000);

        window.useHttp
            .get("/api/v1/broadcast", data, { signal })
            .then(({ body }) => {
                destroySlot(element);

                const template =
                    document.getElementById("tpl-broadcast").innerHTML;
                element.innerHTML = template
                    .replaceAll("{{link}}", `href="${body.link}"`)
                    .replaceAll("{{uuid}}", body.uuid);

                clearTimeout(timeoutId);
            })
            .catch(() => {
                clearTimeout(timeoutId);
            });
    };

    const initTemplate = function (element) {
        const templates = [];

        document
            .querySelectorAll(`template[data-slot="${element.id}"]`)
            .forEach((template) => {
                const { min = null, max = null } = template.dataset;

                const parseMin = parseIntAttr(min, 0);
                const parseMax = parseIntAttr(max, element.offsetWidth);

                if (isSelected(element, parseMin, parseMax)) {
                    templates.push(template);
                }
            });

        if (!templates.length) {
            getBroadcast(element);
            return;
        }

        templates.sort((a, b) => {
            const aPriority = parseFloatAttr(
                a.dataset["priority"] ?? null,
                1.0,
            );
            const bPriority = parseFloatAttr(
                b.dataset["priority"] ?? null,
                1.0,
            );

            if (aPriority === bPriority) {
                const aMax = parseIntAttr(
                    a.dataset["max"] ?? null,
                    element.offsetWidth,
                );
                const bMax = parseIntAttr(
                    b.dataset["max"] ?? null,
                    element.offsetWidth,
                );

                if (aMax === bMax) {
                    return 0;
                }

                return aMax < bMax ? -1 : 1;
            }

            return aPriority < bPriority ? -1 : 1;
        });

        displaySlot(element, templates[templates.length - 1]);
        getBroadcast(element);
    };

    const displaySlot = function (element, template) {
        element.dataset.slotId = template.dataset.slotId ?? null;
        element.appendChild(template.content.cloneNode(true));
    };

    /**
     *
     * @param {Node} element
     * @param {number} min
     * @param {number} max
     * @returns {boolean}
     */
    const isSelected = function (element, min, max) {
        return element.offsetWidth >= min && element.offsetWidth <= max;
    };

    init();
})();
